__turbopack_context__.v({
  "storyList": "StoryList-module-scss-module__fdn6VW__storyList",
});
